import {
  getActAddressBlockId,
  getActInnLabelBlockId,
  getActOgrnLabelBlockId,
  getActOrganizationNameBlockId,
} from 'KnmErknmPackage/MainModule/constants/knmErknmFieldsElementsIds';
import { IKnmPmFormResultDecision } from 'KnmPmPackage/MainModule/interfaces/IKnmPmFormResultDecision';
import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';
import { ErknmSubjectAdd } from 'KnmPmPackage/PmResultOfInspection/components/PmAct/PmActItem/components/PmActSubject/components/PmSubjectInfo';

import styles from './ResultDecisionsPmItemContentSubject.module.scss';

interface IResultDecisionsPmItemContentSubjectProps {
  id: string;
  name: string;
  value: IKnmPmFormResultDecision;
}

export const ResultDecisionsPmItemContentSubject = ({ id, name, value }: IResultDecisionsPmItemContentSubjectProps) => {
  return (
    <div className={styles.Wrapper}>
      <FieldBlock label={'Сведения о контролируемом лице'} />
      <div className={styles.SubjectAdd}>
        <ErknmSubjectAdd
          id={id}
          name={`${name}.organization`}
          inn={value.organization?.inn}
          innLabelBlockId={getActInnLabelBlockId(id)}
          ogrn={value.organization?.ogrn}
          ogrnLabelBlockId={getActOgrnLabelBlockId(id)}
          organizationNameBlockId={getActOrganizationNameBlockId(id)}
          addressBlockId={getActAddressBlockId(id)}
          checkSubjectResult={value.organization?.checkSubjectResult || null}
          subjectType={value.organization?.subjectTypePm}
          snils={value.organization?.snils}
          ervkId={value.organization?.ervkId}
          inspectionResults={value.organization?.inspectionResults}
        />
      </div>
    </div>
  );
};
